import { Box, Stack, Step, StepLabel, Stepper } from "@mui/material";
import CustomerInformationForm from "./checkout/CustomerInformationForm";
import StepWizard from "react-step-wizard";
import 'animate.css';
import ReservationInformationForm from "./checkout/ReservationInformationForm";
import Checkout from "./checkout/Checkout";
import DeliveryInformationForm from "./checkout/DeliveryInformationForm";
import { useForm } from "react-hook-form";
import useCheckoutStore from "../../../../stores/public/useCheckoutStore";

let custom = {
  enterRight: 'animated fadeIn',
  enterLeft : 'animated fadeIn',
  exitRight : 'animated fadeOut',
  exitLeft  : 'animated fadeOut'
};

export default function CheckoutReservation() {
  const { storePage } = useCheckoutStore();

  const deliveryInfoRequired = storePage?.item_category?.deliverable;

  const form = useForm();

  const stepsWithoutDelivery = [
    'Reservation Info',
    'Customer Info',
    'Summary'
  ];

  const stepsWithDelivery = [
    'Reservation Info',
    'Customer Info',
    'Delivery Info',
    'Summary'
  ];

  const steps = deliveryInfoRequired ? stepsWithDelivery : stepsWithoutDelivery;

  const Navigator = ({ currentStep }) => (
    <Box sx={{ width: '100%' }} mb="1rem" mt="2rem">
      <Stepper activeStep={currentStep} alternativeLabel>
        {(steps).map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );

  return (
    <Stack>
      <StepWizard nav={<Navigator />} transitions={custom} isLazyMount>
        <ReservationInformationForm {...form} />
        <CustomerInformationForm  {...form}  />
        <DeliveryInformationForm  {...form}  />
        <Checkout />
      </StepWizard>
    </Stack>
  );
}